import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { BodyRegularS, CaptionRegularM } from '../../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../../styles/theme';

interface IReportsNestedTableTileCont {
  theme: ITheme;
  checked?: boolean;
  buttonsVisible?: boolean;
  is_anonymized?: boolean;
}

export const ReportsNestedTableTileCont = styled(Link)<IReportsNestedTableTileCont>`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  min-height: 40px;
  position: relative;
  z-index: 10;
  ${({ theme, checked, buttonsVisible, is_anonymized }: IReportsNestedTableTileCont) => `
    border-radius: ${buttonsVisible ? '8px 8px 0 8px' : '8px'};
    width: calc(100% - ${theme.layout.spacing.mikro});
    padding: ${theme.layout.spacing.mikro} 41px ${theme.layout.spacing.mikro} ${
  theme.layout.spacing.centy
};
    margin:  0 0 ${theme.layout.spacing.mikro} 0 ;
    opacity: ${is_anonymized ? '1' : '0.75'};
    background: ${checked ? theme.colors.secondary[30] : theme.colors.primary[10]};
    border: ${theme.colors.neutral.primary[30]};
    color: ${
  checked || buttonsVisible
    ? theme.colors.neutral.primary[100]
    : theme.colors.neutral.primary[80]
};
    border-bottom: 1px solid ${theme.colors.primary[70]};
    ${
  is_anonymized
    ? `
      cursor: pointer;
      &:hover { 
        background: ${theme.colors.primary[10]};
      }
    `
    : `
      cursor: default;
    `
}
  `};
`;

export const ReportsNestedTableTileContentCont = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 0 0 0 20px;
`;

export const ReportGroup = styled(BodyRegularS)`
  display: flex;
  align-items: center;
  min-width: 150px;
  max-width: 200px;
  width: 100%;
  @media (min-width: 1360px) {
    min-width: 180px;
    max-width: 300px;
  }
  //width: 180px;
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[90]};
  `};
`;

export const ReportsRegularNestedTableTileEl = styled(ReportGroup)`
  text-transform: capitalize;
  padding-right: 6px;
`;

export const ReportsLowercaseNestedTableTileEl = styled(ReportGroup)`
  padding-right: 6px;
`;

export const ReportTileCont = styled.div`
  position: relative;
`;
export const DownloadIconCont = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 1500;
  top: 11px;
  right: 25px;
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const HoverDownloadCont = styled.div`
  display: block;
  &:hover {
    background: red;
    //display: flex;
  }
`;

export const NoReport = styled(CaptionRegularM)`
  position: absolute;
  top: 40%;
  right: 5%;
  z-index: 1000;
  font-size: 12px;
  opacity: 0.8;
`;

export const TooltipContainer = styled.div`
  text-align: justify;
  ${({ theme }: IThemeProvider) => `
  margin: 0 0 0 ${theme.layout.spacing.mikro};
`}
`;

export const TooltipContent = styled.div`
  display: flex;
  justify-content: flex-start;
  text-align: left;
`;

export const TooltipList = styled.div`
  display: flex;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
`;
